import CONF from './utils/conf';
import optimizedEvents from './utils/optimized-events';
import du from './utils/dom-utilities';
import AjaxSvg from './utils/AjaxSvg';
import ScrollToTop from './components/ScrollToTop';
import buttonBackToTop from './components/button-backtotop';
import bottomEffect from './components/bottomEffect';
import {Lightbox} from './components/lightbox';
import sliderLighbox from './components/slider-lightbox';
import setSticky from './components/sticky';
import {Anchors} from './components/anchor';
import navigationSwipe from './components/navigationSwipe';
import responsiveSwipeItem from './components/responsiveSwipeItem';
import {scrollDown, initHeaderVideo} from './components/header';
import tabQuarterly from './components/tabQuarterly';
import careerForm from './components/careerForm';
import sponsorForm from './components/sponsorForm';
import heightBringer from './components/heightBringer';
import cardThumbnail from './components/cardThumbnail';
import initAccordion from './components/accordion';
import mosaic from './components/mosaic';
import dropDownMenu from './components/dropdown-menu';
import Burger from './components/burger';
import tabPanel from './components/tabPanel';
import {initSliders} from './components/slider.js';
import syncSearchPage from './components/syncSearchPage';
import Quote from './components/quote';
import LastTweet from './components/twitter';
import scrollToBottom from './components/jobOffer';
import squareListAlign from './components/squareList';
import truncate from './components/truncate';
import scrollToFormError from './components/scrollToFormError';

optimizedEvents(['resize', 'scroll']);

const ajaxSvg = new AjaxSvg();
const scrollToTop = new ScrollToTop();
const lightbox = new Lightbox('lightbox', QUEBECOR_TRANSLATE.close);
const burger = new Burger();

ajaxSvg.init(`${CONF.imgPath}sprite/symbol/svg/sprite.symbol.svg`);
scrollToTop.init('.js-back-to-top');

/* eslint-disable max-statements */
du.onEvent(window, 'DOMContentLoaded', function() {

    syncSearchPage();
    bottomEffect('.page', '.page-bottom-effect');
    tabQuarterly();
    careerForm();
    sponsorForm();
    heightBringer();
    tabPanel();

    scrollToBottom();

    scrollToFormError();

    buttonBackToTop();

    sliderLighbox(lightbox);
    initSliders('.js-slider'); // For sliders on document

    let navbar = document.querySelector('.navbar');
    let scrollDowmAction = document.querySelector('.js-hero__scroll');

    if (scrollDowmAction !== null) {
        scrollDown(scrollDowmAction);
    }

    let videoContainer = document.querySelector('[data-header-video]');
    let controlContainer = document.querySelector('[data-header-video-parent-control]');

    if (videoContainer && controlContainer && Modernizr.video) {
        initHeaderVideo(videoContainer, controlContainer);
    }

    if (navbar !== null) {
        setSticky(navbar, navbar.offsetHeight, 'navbar--sticky', CONF.mq.mm, 'navbar-is-sticky');
    }

    let anchorsMenu = new Anchors();
    anchorsMenu.init('.anchor__content', '.js-anchors-frame');

    let anchors = document.querySelector('.anchors');

    if (anchors !== null) {
        let anchorsOffset = parseFloat(window.getComputedStyle(document.querySelector('.header')).height);
        setSticky(anchors, anchorsOffset, 'anchors--sticky', CONF.mq.mm, 'anchors-is-sticky');
    }

    navigationSwipe('.js-navigation-swipe');

    const lastTweet = new LastTweet();
    lastTweet.init();
    responsiveSwipeItem('data-responsive-swipe-item');
    mosaic();
    cardThumbnail('[data-card-thumbnail]', lightbox);

    initAccordion();

    dropDownMenu();

    let burgerNav = document.querySelector(burger.burger);
    if (burgerNav) {
        burger.init(burgerNav);
    }

    const quote = new Quote();
    quote.init();
    squareListAlign();

    truncate();
});
/* eslint-enable max-statement */



// WEBPACK FOOTER //
// ./src/main/js/init.js